@if (iconPath) {
    <div class="flex justify-center items-center mt-5 size-16 bg-[#dcfce7] rounded-full p-3 mx-auto">
        <img class="w-auto h-8" alt="success" [src]="iconPath" />
    </div>
}

<mat-dialog-content class="text-center space-y-2">
    <p class="text-[#0A0A0A] text-[1.125rem] font-bold">{{ title }}</p>
    <p class="text-[#717182] text-[0.875rem]" [innerHTML]="message"></p>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button" class="w-full border-button py-3 rounded-2xl" (click)="onOkay()">
        {{ confirmButtonLabel }}
    </button>
</mat-dialog-actions>
